module.exports = __webpack_public_path__ + "img/a218_verify.79d5b917.png";